<template>
    <div v-if="visible" class="modal-overlay" @click.self="close">
        <div class="modal-container" v-motion-slide-visible-once-bottom>
            <header class="modal-header">
                <slot name="header"></slot>
            </header>
            <section class="modal-body">
                <slot name="body"></slot>
            </section>
            <footer class="modal-footer">
                <slot name="footer"></slot>
            </footer>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Modal",
        props: {
            visible: {
                type: Boolean,
                required: true,
            },
        },
        methods: {
            close() {
                this.$emit("close");
            },
        },
    };
</script>

<style scoped>
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.4);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
    }
    .modal-container {
        background: #fff;
        border-radius: 8px;
        max-width: 500px;
        width: 100%;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        overflow: hidden;
    }
    .modal-header,
    .modal-footer {
        padding: 16px;
        border-bottom: 1px solid #eee;
    }
    .modal-footer {
        border-top: none;
        border-bottom: none;
    }
    .modal-body {
        padding: 16px;
    }
</style>
